import Step from 'shepherd.js/src/types/step';
import {TourSteps} from './interface/tour-steps.interface';

export const assignMealPlanPatientStep: (tourSteps: TourSteps) => Step.StepOptions[] = ({steps, buttons, cb}: TourSteps): Step.StepOptions[] => {
  return [
    {
      ...steps.default,
      id: 'advice51',
      title: 'Nuevo plan de alimentación',
      text: 'En esta sección podrás crear un plan de alimentación completamente nuevo y asignarlo al paciente.',
      attachTo: {
        element: '.shepherd-new-meal-plan',    // @ts-ignore
        on: 'bottom',
      },
      canClickTarget: false,
    },
    {
      ...steps.default,
      id: 'advice52',
      title: 'Seleccionar plan de alimentación',
      text: 'En esta sección podrás escoger entre los planes de alimentación que tiene registrados tu clínica.',
      attachTo: {
        element: '.shepherd-select-meal-plan',    // @ts-ignore
        on: 'bottom',
      },
      canClickTarget: false,
    },
    {
      ...steps.default,
      id: 'registerMealPlanStep12',
      title: 'Plan de alimentación',
      text: 'En esta sección puedes ver los detalles del plan de alimentación que hemos creado y asignado al paciente.',
      attachTo: {
        element: '.shepherd-meal-plan',    // @ts-ignore
        on: 'top'
      },
      canClickTarget: false,
    },
    {
      ...steps.default,
      id: 'registerMealPlanStep12',
      title: 'Plan de alimentación',
      text: 'Aquí se muestra el nombre del plan de alimentación.',
      attachTo: {
        element: '.shepherd-meal-plan-name',    // @ts-ignore
        on: 'top'
      },
      canClickTarget: true,
    },
    {
      ...steps.default,
      id: 'registerMealPlanStep12',
      title: 'Plan de alimentación',
      text: 'Esta sección muestra los macronutrientes con sus respectivos valores.',
      attachTo: {
        element: '.shepherd-meal-plan .macronutrients',    // @ts-ignore
        on: 'top'
      },
      canClickTarget: false,
    },
    {
      ...steps.default,
      id: 'registerMealPlanStep12',
      title: 'Abrir plan de alimentación',
      text: 'Si damos clic sobre este botón nos mostrará la vista, donde podremos hacer modificaciones o ver más detalles del plan de alimentación.',
      attachTo: {
        element: '.shepherd-meal-plan .shepherd-button-open-meal-plan',    // @ts-ignore
        on: 'top'
      },
      canClickTarget: false,
    },
    {
      ...steps.default,
      id: 'registerMealPlanStep12',
      title: 'Asignar plan a una cita',
      text: 'Puedes asignar el plan alimenticio actual a una de tus citas.',
      attachTo: {
        element: '.shepherd-button-assign-meal-plan-to-appointment',    // @ts-ignore
        on: 'top'
      },
      canClickTarget: false,
    },

    {
      ...steps.default,
      id: 'advice52',
      title: 'Listado de planes de alimentación',
      text: 'Aquí podrás visualizar todos los planes de alimentación que han sido asignados al paciente.',
      attachTo: {
        element: 'app-historial-meal-plan-table',    // @ts-ignore
        on: 'top',
      },
      canClickTarget: false,
    },
    {
      ...steps.default,
      id: 'advice52',
      title: 'Descargar PDF',
      text: 'En esta sección podrás descargar un PDF con información relevante del paciente.',
      attachTo: {
        element: '.shepherd-download-pdf',    // @ts-ignore
        on: 'top',
      },
      canClickTarget: false,
    },
    {
      ...steps.default,
      id: 'advice52',
      title: 'Descargar PDF',
      text: 'Para descargar el PDF da clic en el botón.',
      attachTo: {
        element: '.shepherd-button-download-pdf',    // @ts-ignore
        on: 'top',
      },
      advanceOn: {
        selector: '.shepherd-button-download-pdf',
        event: 'click'
      },
      buttons: [{...buttons.cancel}],
    },
    {
      ...steps.default,
      id: 'registerMealPlanStep13',
      title: 'Tour finalizado',
      text: '¡Muy bien!. Has finalizado el tour de "Asignar plan de alimentación a un paciente". Para fines del tour, se eliminarán los datos usados.',
      canClickTarget: false,
      buttons: [
        {
          // tslint:disable-next-line:typedef
          action(): void {
            cb();
          },
          text: 'Entendido',
        }
      ]
    }
  ];
};
